import { useTranslation } from "react-i18next";
import SEOHead from "../components/SEOHead";
import HeroSection from "../sections/HeroSection";
import HeroFeaturesSection from "../sections/HeroFeaturesSection";
import BlockchainsSection from "../sections/BlockchainsSection";

const HomePage = () => {
  const { t } = useTranslation();
  
  return (
    <main role="main" aria-label="Lumina Wallet">
      <SEOHead 
        title={t("home.seo.title")}
        description={t("home.seo.description")}
        path="/"
      />
      <HeroSection />
      <HeroFeaturesSection />
      <BlockchainsSection />
    </main>
  );
};

export default HomePage;
